module.exports = __webpack_public_path__ + "img/placeholder.662c637b.png";